var _style, _line, _line2, _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlIkona(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 128.5 59.8",
    style: {
      enableBackground: "new 0 0 128.5 59.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:none;stroke:#000000;stroke-width:5.94;stroke-miterlimit:10;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pl_ikona") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 77.1,
    y1: 94.9,
    x2: 135,
    y2: 94.9
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 77.7,
    y1: 160.3,
    x2: 163.6,
    y2: 160.3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    className: "st1",
    width: 123,
    height: 53.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.9,34.2v8.4h-6V17.8h9.9c1.9,0,3.6,0.4,5.1,1.1c1.5,0.7,2.6,1.7,3.4,3c0.8,1.3,1.2,2.8,1.2,4.4c0,2.4-0.9,4.4-2.6,5.8 c-1.7,1.5-4.1,2.2-7.2,2.2H50.9z M50.9,29.6h3.9c1.2,0,2-0.3,2.7-0.9c0.6-0.6,0.9-1.4,0.9-2.5c0-1.2-0.3-2.1-0.9-2.8 c-0.6-0.7-1.5-1-2.6-1.1h-4V29.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4,38.1h10.4v4.6H68.4V17.8h6V38.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlIkona);
export default __webpack_public_path__ + "static/media/pl_ikona.692c4efed0eb7f6b3c181e987a895a80.svg";
export { ForwardRef as ReactComponent };